// extracted by mini-css-extract-plugin
module.exports = {"content":"PageLayout_content__fG2xO","pageLayout":"PageLayout_pageLayout__Ndcmb","innerContent":"PageLayout_innerContent__doQRU","page":"PageLayout_page__apzPC"};